import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

import { useLanguage } from "@/contexts/LanguageContext";
import { LANGUAGE_LABELS } from "@/i18n/config";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function LanguageSwitcher({
  className,
  side = "top",
}: {
  className?: string;
  side?: "top" | "right";
}) {
  const { t } = useTranslation("layout");
  const { language, setLanguage, languages } = useLanguage();

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className={cn(className)}
              aria-label={t("selectLanguage")}
            >
              <Languages />
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent side={side}>{t("selectLanguage")}</TooltipContent>
      </Tooltip>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onSelect={() => setLanguage(lang)}
            className={cn(lang === language && "font-semibold")}
          >
            {LANGUAGE_LABELS[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
